import React, { useState, useEffect } from "react";
import Header from "../components/Header/Header";
import Footer from "../components/MainWebsiteComponent/Footer/Footer";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import HomeIcon from "@material-ui/icons/Home";
import styles from "./Tos.module.css";
import Head from "next/head";

function Terms(props) {
  const breadcrumbsData = [
    {
      label: "Home",
      link: "/",
      icon: <HomeIcon fontSize="small" />,
    },

    {
      label: "Terms of Use",
      link: "",
    },
  ];

  return (
    <div>
      <Header />
      <div
        style={{
          borderBottom: "1px solid rgb(235 235 235)",
          paddingTop: "22px",
        }}
      >
        <Container maxWidth="lg">
          <Breadcrumbs breadcrumbsData={breadcrumbsData} />
        </Container>
      </div>
      <div className="Section">
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <div className={styles.TosContainer}>
                <h1 className={styles.PageTitle}>Terms of Services</h1>
                <div className={styles.TosDate}>
                  As of March 12th, 2023, these Terms of Services ("Terms") have
                  been updated.{" "}
                </div>

                <p>
                  Takbir’s ultimate objective is to make a difference in
                  people's lives through education. We make it possible for
                  everyone, regardless of location, to produce and distribute
                  educational content (instructors) and to access that content
                  for learning purposes (learners). We trust that our platform
                  is the most effective approach for providing our users with
                  valuable educational resources.{" "}
                </p>

                <p>
                  To ensure the safety of our platform and services for all
                  parties involved, we have established guidelines. These Terms
                  are applicable to all activities that take place on the Takbir
                  platform, mobile applications, APIs, and other associated
                  services ("Services").
                </p>
                <p>
                  If you plan on creating a course on the Takbir platform, you
                  must also agree to the Instructor Terms. In addition, we
                  provide information about the handling of personal information
                  for both our students and instructors in our Privacy Policy.
                </p>
                <h2>Accounts:</h2>
                <p>
                  Most activities on our platform require an account. Please
                  keep your password safe, as you are responsible for all
                  activities related to your account. If you think someone else
                  is using your account, don't hesitate to contact our{" "}
                  <a href="https://support.mytakbir.com/">support team.</a> To
                  use Takbir, you must be of legal age in your country to
                  utilize online services.
                </p>
                <p>
                  To engage in most activities on our Platform, such as buying
                  or accessing Content, or submitting Content for publication,
                  it is necessary to have an account. When setting up and
                  maintaining an account, it is crucial to provide precise and
                  complete information, including a valid email address.
                </p>
                <p>
                  You are solely responsible for your account, including any
                  actions taken by unauthorized individuals that may result in
                  damage to us or others. It is not permissible to transfer or
                  use another person's account. In the event that you need
                  access to an account, we will only grant it if you can prove
                  that you are the account owner. If a user passes away, their
                  account will be terminated.
                </p>
                <p>
                  You may not share your account credentials with any third
                  party. You are responsible for what happens to your account,
                  and Takbir will not intervene in disputes between learners or
                  faculty who share account credentials. You must notify us
                  immediately if you become aware of anyone else using your
                  account without your consent (or if you suspect any other
                  security breach) by contacting our{" "}
                  <a href="https://support.mytakbir.com/">support team.</a> We
                  may ask you for some information to confirm that you are the
                  owner of your account.
                </p>
                <p>
                  In order to create an account with Takbir and use its
                  services, both learners and instructors need to be at least 18
                  years old. If you are under 18 but have reached the age of
                  consent for online services in your area, you are not eligible
                  to create an account. Nevertheless, we recommend that you
                  request a parent or legal guardian to create an account on
                  your behalf and help you access the appropriate content. If
                  you are under the required age to use online services, you
                  cannot register for an Takbir account. If we discover that you
                  have created an account in violation of these policies, your
                  account will be terminated. If you are an instructor, it may
                  be necessary for you to verify your identity prior to
                  submitting any content for publication on Takbir.
                </p>
                <h2>Lifetime Access and Content Enrollment</h2>
                <p>
                  When you sign up for a course or other materials on Takbir,
                  you are given permission to display it solely through Takbir
                  Services and not for any other purposes. Any content uploaded
                  on Takbir becomes the property of Takbir and cannot be
                  transferred or resold. In general, you will have a lifetime
                  license to access the content unless specified otherwise or
                  you opt out for legal or political reasons. <br /> As for
                  instructors, when they upload content on Takbir, they are
                  giving Takbir the authority to license it to learners. This
                  means that Takbir can sub-license the content to enrolled
                  learners. As a learner, when you register for any Takbir free
                  or paid content, you have the right to view it through the
                  Takbir Platform and Services, and Takbir is the licensor. Keep
                  in mind that the content is licensed and not sold to you, and
                  you are not allowed to resell it in any way (including by
                  sharing your account information with a buyer or illegally
                  downloading and sharing it on torrent websites).
                </p>
                <p>
                  Takbir provides you, as a learner, with a limited,
                  non-exclusive, and non-transferable license to access and
                  display paid Content solely for your personal and educational
                  use through the Services. However, you must have paid all
                  applicable fees and abide by these terms as well as any
                  additional terms, conditions, or restrictions related to
                  specific content or features of our Services.
                </p>
                <p>
                  Using the Content for any other purpose is strictly
                  prohibited. You are not allowed to reproduce, redistribute,
                  transmit, assign, sell, broadcast, rent, share, loan, modify,
                  adapt, publish, create derivative works, sublicense, or
                  exploit any content unless you have obtained permission from
                  us or have a written agreement signed by an authorized
                  representative of Takbir. This also includes any Content
                  accessed through our APIs.
                </p>
                <p>
                  When learners register for a course or other content, we
                  typically provide them with a lifetime access license.
                  However, we retain the right to revoke this license at any
                  time if we deem it necessary, such as in cases where there is
                  a legal or political requirement to disable access, or if the
                  content is found to violate our trust and security policies,
                  such as in cases of copyright infringement.{" "}
                </p>
                <p>
                  Please note that this lifetime access license does not apply
                  to enrollments through subscription plans or additional
                  features and services related to the course or other content.
                  This means that instructors may choose to discontinue
                  providing teaching materials or content-related Q&A services
                  at any time. It's important to clarify that learners have
                  lifetime access to the course content, but not to the
                  instructor. It's not allowed for instructors to provide
                  licenses directly to learners, and such licenses will be
                  considered void and a violation of our terms.
                </p>

                <h2>Refund Policy</h2>
                <p>
                  If you're unsatisfied with your purchase, you may request a
                  refund from the instructor or teaching account according to
                  their refund policies. Please note that certain transactions
                  might not qualify for a refund. Refunds will be subject to the
                  policies set by the teaching account, and we reserve the right
                  to determine if the refund will be issued as credit or
                  returned to the original payment method. Refunds might not be
                  available after the specified time frame set by the teaching
                  account. To safeguard against abuse of our refund policy, we
                  may refuse a refund if we suspect improper use or abuse of
                  refund policy, such as significant use of the content before
                  requesting a refund or requesting refunds for content already
                  paid for. Abuse of the refund policy could result in
                  limitations on future refunds, suspension of your account, or
                  restricted access to our services.
                </p>
                <h2>Payment and Security</h2>
                <p>
                  We prioritize the security of your payment information by
                  partnering with Stripe, a trusted payment service provider.
                  Employing industry-leading encryption and data protection
                  standards, Stripe guarantees the confidentiality and integrity
                  of your payment details throughout the transaction process.
                </p>
                <p>
                  It's crucial to note that Takbir does not store any user
                  payment information. Once a transaction is processed through
                  our platform using Stripe's secure infrastructure, all
                  sensitive payment data is immediately encrypted and handled
                  exclusively by Stripe. Takbir does not store user payment
                  information; for further details on security measures, please
                  refer to{" "}
                  <a href="https://stripe.com/legal/ssa">
                    Stripe's Services Agreement
                  </a>{" "}
                  and
                  <a href="https://stripe.com/privacy">Privacy Policy</a>.
                </p>
                <h2>Delivery Policy</h2>
                <p>
                  Our delivery policy is designed to provide swift and
                  hassle-free access to course materials. Upon enrollment,
                  learners instantly gain access to free courses, enabling an
                  immediate start to their learning journey. For paid courses,
                  access is granted promptly following successful payment
                  confirmation. This approach ensures a seamless transition to
                  the course content, emphasizing our commitment to facilitating
                  efficient and timely access to educational resources.
                </p>
                <p>
                  It's important to note that teaching accounts hold the right
                  to modify, remove, or discontinue any free course. Course
                  durations may vary, providing flexibility within our platform.
                  Users are entrusted with the responsibility of adhering to
                  platform policies, maintaining the security of their
                  credentials, and complying with acceptable use practices.
                </p>
                <p>
                  For inquiries or further information regarding course
                  availability, users can directly contact the teaching account.
                  Our platform values clear communication and encourages users
                  to engage with teaching accounts for any inquiries or specific
                  course-related details.
                </p>
                <h2>Return Policy</h2>
                <p>
                  As an LMS (Learning Management System), our platform serves as
                  an intermediary, fostering direct communication between
                  learners and instructors. If there are any queries or requests
                  regarding returns, learners have the option to directly
                  contact the teaching account or instructor for comprehensive
                  assistance. Instructors will review these requests,
                  considering factors such as course materials, completion
                  status, and adherence to refund criteria. Communication of
                  return or refund decisions will be conveyed directly from
                  instructors to learners, specifying outcomes and any
                  additional steps. This streamlined communication channel
                  ensures prompt resolution of any concerns related to course
                  materials or potential returns. This policy is periodically
                  reviewed to ensure it aligns with our commitment to
                  facilitating effective learner-instructor interaction and
                  satisfactory learning experiences.
                </p>
                <h2>Cancellation Policy</h2>
                <p>
                  Given the nature of our business as an LMS, cancellations
                  might not typically apply. Learners have immediate access to
                  free content, while paid content access follows successful
                  payment processing. While traditional cancellations may not
                  apply, exceptions might exist in specific cases. For instance,
                  discrepancies in course delivery, content quality, or other
                  unforeseen circumstances might warrant exceptional
                  consideration. These cases will be evaluated on an individual
                  basis to ensure fairness and an optimal learning experience
                  for our users. Users encountering such circumstances and
                  seeking a cancellation should submit a detailed request
                  through our designated support channels. Our team will
                  meticulously assess these requests based on the outlined
                  criteria and communicate decisions directly to the user,
                  providing outcomes and any necessary instructions. This policy
                  undergoes regular reviews to ensure alignment with our
                  commitment to fairness and continuous improvement in
                  addressing exceptional circumstances for the benefit of our
                  users' learning journeys.
                </p>
                <h2>Certificates and Refund</h2>
                <p>
                  Teaching accounts have the option to offer certificates and
                  upload them for learner access. Takbir facilitates this
                  process as a platform, ensuring accessibility of these
                  certificates. It's important to note that Takbir's role is to
                  enable access; the actual issuance of certificates is the
                  responsibility of the teaching account. Learners can securely
                  access these certificates uploaded by their instructors via
                  our platform. Any concerns or requests regarding certificates
                  should be directed to the respective teaching account.
                </p>
                <p>
                  In cases where there's a lack of transparency from the
                  teaching account, students can raise a dispute. Takbir will
                  then communicate the concern to the teaching account for
                  resolution.
                </p>
                <h2>Responsibility and Disputes</h2>
                <p>
                  Learners hold accountability for fulfilling the eligibility
                  criteria specified for certificates. Failure to meet these
                  criteria may result in the inability to dispute or claim
                  certificates. Ensuring compliance with the outlined
                  requirements by teaching accounts is pivotal for students to
                  assert their eligibility for certificates within our platform.
                </p>
                <p>
                  Unless stated otherwise in this Refund Policy or explicitly
                  mentioned during the purchase process of a learner account,
                  Takbir is not obligated to issue refunds, vouchers, or
                  entitlements for any other product or service provided via the
                  Service.
                </p>
                <h2>Content and Conduct Policy</h2>
                <p>
                  The use of Takbir is limited to lawful purposes only. You bear
                  sole responsibility for all content that you post on our
                  platform, and must respect the intellectual property rights of
                  others. If you repeatedly or seriously violate these rules, we
                  may suspend your account. Additionally, if you become aware of
                  any copyright infringement on our platform, please inform us
                  immediately.
                </p>
                <p>
                  It is prohibited to access or create an account on our
                  platform for any illegal purpose. Your behavior on the
                  platform and use of our services must comply with applicable
                  local or national laws and regulations. It is your
                  responsibility to stay informed and comply with all relevant
                  laws and regulations.
                </p>
                <p>
                  As a learner, you can use the Services to ask questions about
                  the content you are enrolled in and provide reviews.
                  Instructors may request that you submit content such as
                  "Assignments" or tests. Please refrain from posting or
                  uploading content that is not your own.
                </p>
                <p>
                  As an instructor, you have the option to upload content for
                  publication on the platform and interact with enrolled
                  learners. However, it is important to adhere to the law and
                  respect the rights of others. This means that you cannot post
                  any lesson, question, answer, review, or other content that
                  violates any local or national laws or regulations applicable
                  in your country. You are solely responsible for all courses,
                  content, and actions you post or take through the platform and
                  Services, and you will be held accountable for any
                  consequences that arise from them.
                </p>
                <p>
                  If we discover that your course or content violates the law or
                  the rights of others, or if we determine that your content or
                  behavior violates our policies, we may remove your content
                  from our platform. We value copyright and may limit or revoke
                  your permission to use our platform and services or terminate
                  your account, with or without notice, for any reason,
                  including your breach of these Terms. If your account is
                  terminated, we may delete your content and account, and
                  prevent you from accessing the platform and using our
                  services. It is important to note that your content may still
                  be accessible on the platform even if your account is closed
                  or suspended. By using our platform and services, you agree
                  that we will not be held liable for any termination of your
                  account, removal of your content, or suspension of your access
                  to our platforms and services.
                </p>
                <p>
                  If you believe that a user has posted content that infringes
                  on your copyright or trademark, please notify us. Our
                  instructors are expected to follow the law and respect the
                  intellectual property rights of others.
                </p>
                <h2>Using the Platform at Your Own Risk:</h2>
                <p>
                  Takbir is a platform that allows anyone to generate and share
                  content, and it also offers a space for educators and learners
                  to engage in teaching and learning activities. However,
                  similar to other platforms that permit content creation and
                  social interaction, there is a potential risk for things to go
                  awry, and therefore, you assume personal responsibility for
                  using Takbir.
                </p>
                <p>
                  Takbir operates on a model that excludes any review or editing
                  of Content for legal purposes, which renders us incapable of
                  assessing the legality of any given Content. We do not exert
                  editorial oversight over the Content that is accessible on the
                  Platform, and thus, we do not vouch for its dependability,
                  credibility, precision, or veracity. Should you choose to
                  access the Content, you are solely responsible for relying on
                  the information provided by the instructor and assume all
                  associated risks.
                </p>
                <p>
                  By utilizing our Services, you may come across Content that
                  you might find objectionable, indecent, or offensive. Takbir
                  will not be held accountable for preventing you from accessing
                  such Content, or enrolling in courses or other Content, to the
                  extent allowed by applicable law. This also pertains to all
                  Content relating to health, wellness, and exercise.{" "}
                </p>
                <p>
                  You understand and acknowledge the potential hazards and
                  dangers that are inherent in consuming such Content. By
                  choosing to access such Content, you are doing so voluntarily
                  and assuming any potential risks, including the risk of
                  becoming ill, getting injured, becoming disabled, or even
                  facing death. It is your responsibility to make informed
                  decisions both prior to and following your exposure to the
                  Content.
                </p>
                <p>
                  It's important to exercise caution when sharing personal
                  information with learners or instructors. Although we place
                  limits on the information instructors can request from
                  learners, we have no control over what information learners
                  and instructors share with each other on the Platform. For
                  security reasons, it's recommended that you avoid sharing
                  personal information such as your email address.
                </p>
                <p>
                  Please note that we don't hire instructors and are not
                  responsible for their interactions with learners. We are not
                  liable for any disputes, claims, losses, injuries, or damages
                  that may arise from the behaviour of any instructor or
                  learner.
                </p>
                <p>
                  When using our Services, you may encounter links to external
                  websites that we don't own or have control over. We cannot be
                  held responsible for the content or any other aspect of these
                  third-party websites, including their collection of your
                  personal information. Be sure to review their terms of service
                  and privacy policy.
                </p>
                <h2>Our Rights</h2>
                <p>
                  The Takbir Platform and its accompanying services, comprising
                  our present and forthcoming website, apps, services, and items
                  such as our logo, APIs, code, and Content produced by our
                  employees, are under our ownership. Any attempt to interfere
                  with or utilize them without authorization is prohibited.
                </p>
                <p>
                  The Takbir Platform and its services, encompassing the
                  website, present and future applications, APIs, databases, and
                  Content provided by our employees or partners, are exclusively
                  owned by Takbir and its licensors, and shall remain so.
                  Copyright, trademark, and other applicable laws of the United
                  States and other countries protect our Platforms and Services.
                </p>
                <p>
                  You do not have the authorization to utilize the Takbir name
                  or any Takbir trademark, logo, domain name, or other unique
                  design. Any feedback, comments, or suggestions related to
                  Takbir or the Services are completely voluntary, and we
                  reserve the right to utilize such feedback, comments, or
                  suggestions at our own discretion without any obligation to
                  you.
                </p>
                <h2>Payments and Billing</h2>
                <p>
                  Content pricing on Takbir is subject to the terms of
                  individual teaching accounts, and may be discounted during
                  promotional sales for a limited time. At checkout, the price
                  for content will be the prevailing price. Registered users may
                  have access to different pricing for certain content, as some
                  promotional offers are exclusive to new users.
                </p>
                <p>
                  The currency you see listed on your account depends on your
                  location at the time of account creation, while the currency
                  displayed for non-logged in users is based on their current
                  country of location. We do not offer the option to view prices
                  in different currencies.
                </p>
                <h2>Disclaimer</h2>
                <p>
                  We cannot ensure that a particular subscription plan will have
                  specific content or a minimum amount of content. We retain the
                  authority to add or remove additional features from any
                  subscription plan, as well as change or terminate any
                  subscription plan, at our sole discretion. Additionally, we
                  are not accountable for the upkeep or preservation of any
                  content that is uploaded as part of a subscription plan.
                </p>
                <h2>Binding Contract</h2>
                <p>
                  This excerpt is a statement from Takbir that outlines the
                  terms and conditions for using their services. By accessing or
                  using the services provided by Takbir, the user agrees to be
                  bound by the terms of this contract. If the user does not
                  agree with these terms, they should not use the services.
                </p>
                <p>
                  If the user is an instructor and is using the services on
                  behalf of a legal entity such as a company, organization, or
                  government, they represent and warrant that they have the
                  authority to do so. This ensures that the user has the
                  necessary permissions and legal standing to agree to the terms
                  of the contract on behalf of the entity they represent.
                </p>
                <p>
                  In the event that any part of these Terms is deemed invalid or
                  unenforceable under applicable law, a valid and enforceable
                  provision that best aligns with the original provision's
                  intent will replace it, and the rest of these Terms will
                  remain in effect. Our failure to enforce any of our rights
                  under these Terms or any delay in doing so does not constitute
                  a waiver of those rights, and we reserve the right to enforce
                  them in the future. Any waiver of our rights in a particular
                  situation does not constitute a general waiver of our rights
                  or waive them in the future.
                </p>
                <h2>Reservations</h2>
                <p>
                  Our Platform may occasionally experience downtime due to
                  scheduled maintenance or a website outage, and there is a
                  possibility that our lecturers may provide inaccurate
                  information, or we may encounter security issues. It is
                  important to note that these are just examples, and in the
                  event that something goes wrong, you agree not to hold us
                  liable. We, along with our affiliates, suppliers, partners,
                  and agents, do not guarantee any specific results from your
                  use of the Services, and your use of the Services is entirely
                  at your own risk. Please note that some jurisdictions may not
                  allow the exclusion of implied warranties, so some of the
                  exclusions mentioned may not apply to you.
                </p>
                <p>
                  We reserve the right to discontinue certain features of the
                  Services at any time, and we will not be liable for any
                  damages resulting from such an interruption. Additionally, we
                  are not responsible for any delays or failures in providing
                  our services due to circumstances beyond our control, such as
                  acts of war, natural disasters, power, internet, or
                  telecommunication outages, or government restrictions.
                </p>
                <h2>Limitation of Liability:</h2>
                <p>
                  Our Services come with inherent risks that you acknowledge and
                  accept in their entirety. By using our Platform and Services,
                  you agree that you are not entitled to any compensation, even
                  if you experience any loss or damage. If your behaviour poses
                  legal issues, we reserve the right to take legal action
                  against you.
                </p>
                <h2>Indemnification:</h2>
                <p>
                  By using the Services, you acknowledge and accept that you
                  will be responsible for any indemnification related to the
                  following: the Content you upload or post, your use of the
                  Services, your breach of these Terms, and any infringement of
                  third-party rights. It's important to note that your
                  obligation to indemnify will continue even after the
                  termination of these Terms and your use of the Services.
                </p>
                <h2>The relationship between us</h2>
                <p>
                  Both parties, you and we, acknowledge that there is no joint
                  venture, partnership, employment, contractor, or agency
                  relationship in existence between us.
                </p>
                <p>
                  Dispute Resolution Both parties, you and we, concur that there
                  is no association of joint venture, partnership, employment,
                  contractor or agency between us.
                </p>
                <h2>Update to these Terms</h2>
                <p>
                  From time to time, we may revise these Terms to provide
                  clarification on our procedures or to reflect new or varied
                  practices, such as the addition of new features. Takbir
                  maintains the right to modify the Terms at any time according
                  to its sole discretion. If a significant change is made, we
                  will provide you with a noticeable notification, such as
                  sending an email to the email address you provided in your
                  account or posting information on our Services. Unless
                  otherwise specified, changes to the Terms become effective on
                  the date they are posted. Your continued use of our Services
                  following the implementation of the changes constitutes your
                  acceptance of them. Any amended terms take precedence over all
                  previous terms.
                </p>
                <h2>Reach us</h2>
                <p>
                  The best way to contact us is through our{" "}
                  <a href="https://support.mytakbir.com/">support team.</a> We'd
                  love your questions, concerns, and opinions about our
                  services.
                </p>
                <p>Thank you for teaching and learning with us!</p>
                {/* <ul>
                  <li>
                    our use of your personal information is necessary to perform
                    our obligations under any contract with you (for example, to
                    comply with the Terms of Use of our Site which you accept by
                    browsing our website and/or to comply with our contract to
                    provide Services to you, your academic institution, your
                    employer, or other organization that may be providing you
                    with access to our Services); or
                  </li>
                  <li>
                    our use of your personal information is necessary to perform
                    our obligations under any contract with you (for example, to
                    comply with the Terms of Use of our Site which you accept by
                    browsing our website and/or to comply with our contract to
                    provide Services to you, your academic institution, your
                    employer, or other organization that may be providing you
                    with access to our Services); or
                  </li>
                  <li>
                    our use of your personal information is necessary to perform
                    our obligations under any contract with you (for example, to
                    comply with the Terms of Use of our Site which you accept by
                    browsing our website and/or to comply with our contract to
                    provide Services to you, your academic institution, your
                    employer, or other organization that may be providing you
                    with access to our Services); or
                  </li>
                </ul> */}

                {/* <ol>
                  <li>
                    our use of your personal information is necessary to perform
                    our obligations under any contract with you (for example, to
                    comply with the Terms of Use of our Site which you accept by
                    browsing our website and/or to comply with our contract to
                    provide Services to you, your academic institution, your
                    employer, or other organization that may be providing you
                    with access to our Services); or
                  </li>
                  <li>
                    our use of your personal information is necessary to perform
                    our obligations under any contract with you (for example, to
                    comply with the Terms of Use of our Site which you accept by
                    browsing our website and/or to comply with our contract to
                    provide Services to you, your academic institution, your
                    employer, or other organization that may be providing you
                    with access to our Services); or
                  </li>
                  <li>
                    our use of your personal information is necessary to perform
                    our obligations under any contract with you (for example, to
                    comply with the Terms of Use of our Site which you accept by
                    browsing our website and/or to comply with our contract to
                    provide Services to you, your academic institution, your
                    employer, or other organization that may be providing you
                    with access to our Services); or
                  </li>
                </ol> */}
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
      z
      <div>
        <Footer />
      </div>
    </div>
  );
}

export default Terms;
